type Range = (length: number) => number[];

export const range: Range = length => Array.from({ length }, (_, i) => i);
